var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showReferralsStart)?_c('ReferralStart'):_vm._e(),(_vm.showReferralsSearch)?_c('ReferralSearch'):_vm._e(),_c('ContactUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }